import { useTranslation } from 'react-i18next';
import "../totp/sidemenu/PrivacyPolicy.css"

export default function PrivacyPolicyContents() {
  
  const { t } = useTranslation();

  return (
    <div className="page-content">
      <div className="privacy-policy-content">
        <section className="policy-section">
          <h3>{t('privacy.generalTitle')}</h3>
          <p>{t('privacy.generalText1')}</p>
          <p>{t('privacy.generalText2')}</p>
          <p>{t('privacy.generalText3')}</p>
        </section>

        <section className="policy-section">
          <h3>{t('privacy.storageTitle')}</h3>
          <h4>Android</h4>
          <p>{t('privacy.storageAndroid')}</p>
          <h4>iPhone</h4>
          <p>{t('privacy.storageIos')}</p>
        </section>

        <section className="policy-section">
          <h3>{t('privacy.cameraTitle')}</h3>
          <p>{t('privacy.cameraText1')}</p>
          <p>{t('privacy.cameraText2')}</p>
          <p>{t('privacy.cameraText3')}</p>
        </section>

        <section className="policy-section">
          <h3>{t('privacy.collectedDataTitle')}</h3>
          <table className="policy-table">
            <thead>
              <tr>
                <th>{t('privacy.collectedDataColItem')}</th>
                <th>{t('privacy.collectedDataColPurpose')}</th>
                <th>{t('privacy.collectedDataColStatus')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>이메일</td>
                <td>{t('privacy.collectedDataEmailPurpose')}</td>
                <td>✅</td>
              </tr>
              <tr>
                <td>{t('privacy.collectedDataDevice')}</td>
                <td>{t('privacy.collectedDataUsagePurpose')}</td>
                <td>✅</td>
              </tr>
              <tr>
                <td>{t('privacy.collectedDataCountry')}</td>
                <td>{t('privacy.collectedDataUsagePurpose')}</td>
                <td>✅</td>
              </tr>
              <tr>
                <td>device_uuid</td>
                <td>{t('privacy.collectedDataUuidPurpose')}</td>
                <td>✅</td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>
    </div>
  )

}